import { Set } from 'immutable';

import { isTrue, isTruthy } from '../utils/bool';

import { SEPARATOR } from '.';

function makeWhitelist(featureFlag) {
  switch (featureFlag) {
    case 'all':
    case 'none': {
      return featureFlag;
    }

    default: {
      return Set((featureFlag || '').split(SEPARATOR.COMMA).filter(isTruthy));
    }
  }
}

export const INFLUENCERS = makeWhitelist(process.env.INFLUENCERS);

export const ACTIVATE_SHOP_ENABLED = isTrue(process.env.FEATURE_FLAG_ACTIVATE_SHOP);
export const ACTIVATE_SHOP_USERS = makeWhitelist(process.env.FEATURE_FLAG_ACTIVATE_SHOP_USERS);

export const AFFILIATES_ENABLED = isTrue(process.env.FEATURE_FLAG_AFFILIATES);
export const AFFILIATES_USERS = makeWhitelist(process.env.FEATURE_FLAG_AFFILIATES_USERS);

export const AI_COPY_ENABLED = isTrue(process.env.FEATURE_FLAG_AI_COPY);
export const AI_COPY_USERS = makeWhitelist(process.env.FEATURE_FLAG_AI_COPY_USERS);

export const AI_PROFILES_ENABLED = isTrue(process.env.FEATURE_FLAG_AI_PROFILES);
export const AI_PROFILES_USERS = makeWhitelist(process.env.FEATURE_FLAG_AI_PROFILES_USERS);

export const AI_STRATEGY_SUPPORT_ENABLED = isTrue(process.env.FEATURE_FLAG_AI_STRATEGY_SUPPORT);
export const AI_STRATEGY_SUPPORT_USERS = makeWhitelist(process.env.FEATURE_FLAG_AI_STRATEGY_SUPPORT_USERS);

export const AI_V2_ENABLED = isTrue(process.env.FEATURE_FLAG_AI_V2);
export const AI_V2_USERS = makeWhitelist(process.env.FEATURE_FLAG_AI_V2_USERS);

export const HELP_CENTER_ENABLED = isTrue(process.env.FEATURE_FLAG_HELP_CENTER);
export const HELP_CENTER_USERS = makeWhitelist(process.env.FEATURE_FLAG_HELP_CENTER_USERS);

export const IMAGE_GROUPING_ENABLED = isTrue(process.env.FEATURE_FLAG_IMAGE_GROUPING);
export const IMAGE_GROUPING_USERS = makeWhitelist(process.env.FEATURE_FLAG_IMAGE_GROUPING_USERS);

export const LISTING_SCORE_ENABLED = isTrue(process.env.FEATURE_FLAG_LISTING_SCORE);
export const LISTING_SCORE_USERS = makeWhitelist(process.env.FEATURE_FLAG_LISTING_SCORE_USERS);

export const MERGE_LISTINGS_ENABLED = isTrue(process.env.FEATURE_FLAG_MERGE_LISTINGS);
export const MERGE_LISTINGS_USERS = makeWhitelist(process.env.FEATURE_FLAG_MERGE_LISTINGS_USERS);

export const PHOTO_CONTROLS_ENABLED = isTrue(process.env.FEATURE_FLAG_PHOTO_CONTROLS);
export const PHOTO_CONTROLS_USERS = makeWhitelist(process.env.FEATURE_FLAG_PHOTO_CONTROLS_USERS);

export const PHOTO_EDITOR_LAYERS_ENABLED = isTrue(process.env.FEATURE_FLAG_PHOTO_EDITOR_LAYERS);
export const PHOTO_EDITOR_LAYERS_USERS = makeWhitelist(process.env.FEATURE_FLAG_PHOTO_EDITOR_LAYERS_USERS);

export const PHOTO_EDITOR_VIDEO_ENABLED = isTrue(process.env.FEATURE_FLAG_PHOTO_EDITOR_VIDEO);
export const PHOTO_EDITOR_VIDEO_USERS = makeWhitelist(process.env.FEATURE_FLAG_PHOTO_EDITOR_VIDEO_USERS);

export const PROCESSING_PROFILES_ENABLED = isTrue(process.env.FEATURE_FLAG_PROCESSING_PROFILES);
export const PROCESSING_PROFILES_USERS = makeWhitelist(process.env.FEATURE_FLAG_PROCESSING_PROFILES_USERS);

export const PUBLIC_ERRORS_ENABLED = isTrue(process.env.FEATURE_FLAG_PUBLIC_ERRORS);
export const PUBLIC_ERRORS_USERS = makeWhitelist(process.env.FEATURE_FLAG_PUBLIC_ERRORS_USERS);

export const REDESIGN_ENABLED = isTrue(process.env.FEATURE_FLAG_REDESIGN);
export const REDESIGN_USERS = makeWhitelist(process.env.FEATURE_FLAG_REDESIGN_USERS);

export const STAGING_STATUS_ENABLED = isTrue(process.env.FEATURE_FLAG_STAGING_STATUS);
export const STAGING_STATUS_USERS = makeWhitelist(process.env.FEATURE_FLAG_STAGING_STATUS_USERS);

export const STUDIO_AI_EDIT_ENABLED = isTrue(process.env.FEATURE_FLAG_STUDIO_AI_EDIT);
export const STUDIO_AI_EDIT_USERS = makeWhitelist(process.env.FEATURE_FLAG_STUDIO_AI_EDIT_USERS);

export const TEMPLATE_MODE_PROFILES_ENABLED = isTrue(process.env.FEATURE_FLAG_TEMPLATE_MODE_PROFILES);
export const TEMPLATE_MODE_PROFILES_USERS = makeWhitelist(process.env.FEATURE_FLAG_TEMPLATE_MODE_PROFILES_USERS);

export const VIDEO_STUDIO_ENABLED = isTrue(process.env.FEATURE_FLAG_VIDEO_STUDIO);
export const VIDEO_STUDIO_USERS = makeWhitelist(process.env.FEATURE_FLAG_VIDEO_STUDIO_USERS);

export const WISHLIST_BANNER_ENABLED = isTrue(process.env.FEATURE_FLAG_WISHLIST_BANNER);
export const WISHLIST_BANNER_USERS = makeWhitelist(process.env.FEATURE_FLAG_WISHLIST_BANNER_USERS);

export const FEATURE_FLAG = {
  ACTIVATE_SHOP_ENABLED,
  ACTIVATE_SHOP_USERS,
  AFFILIATES_ENABLED,
  AFFILIATES_USERS,
  AI_COPY_ENABLED,
  AI_COPY_USERS,
  AI_PROFILES_ENABLED,
  AI_PROFILES_USERS,
  AI_STRATEGY_SUPPORT_ENABLED,
  AI_STRATEGY_SUPPORT_USERS,
  AI_V2_ENABLED,
  AI_V2_USERS,
  HELP_CENTER_ENABLED,
  HELP_CENTER_USERS,
  IMAGE_GROUPING_ENABLED,
  IMAGE_GROUPING_USERS,
  LISTING_SCORE_ENABLED,
  LISTING_SCORE_USERS,
  MERGE_LISTINGS_ENABLED,
  MERGE_LISTINGS_USERS,
  PHOTO_CONTROLS_ENABLED,
  PHOTO_CONTROLS_USERS,
  PHOTO_EDITOR_LAYERS_ENABLED,
  PHOTO_EDITOR_LAYERS_USERS,
  PHOTO_EDITOR_VIDEO_ENABLED,
  PHOTO_EDITOR_VIDEO_USERS,
  PROCESSING_PROFILES_ENABLED,
  PROCESSING_PROFILES_USERS,
  PUBLIC_ERRORS_ENABLED,
  PUBLIC_ERRORS_USERS,
  REDESIGN_ENABLED,
  REDESIGN_USERS,
  STAGING_STATUS_ENABLED,
  STAGING_STATUS_USERS,
  STUDIO_AI_EDIT_ENABLED,
  STUDIO_AI_EDIT_USERS,
  TEMPLATE_MODE_PROFILES_ENABLED,
  TEMPLATE_MODE_PROFILES_USERS,
  VIDEO_STUDIO_ENABLED,
  VIDEO_STUDIO_USERS,
  WISHLIST_BANNER_ENABLED,
  WISHLIST_BANNER_USERS,
};

export const FEATURE = {
  ACTIVATE_SHOP: 'activate-shop',
  AFFILIATES: 'affiliates',
  AI_COPY: 'ai-copy',
  AI_PROFILES: 'ai-profiles',
  AI_V2: 'ai-v2',
  AI_STRATEGY_SUPPORT: 'ai-strategy-support',
  HELP_CENTER: 'help-center',
  IMAGE_GROUPING: 'image-grouping',
  LISTING_SCORE: 'listing-score',
  MERGE_LISTINGS: 'merge-listings',
  PHOTO_CONTROLS: 'photo-controls',
  PHOTO_EDITOR_LAYERS: 'photo-editor-layers',
  PHOTO_EDITOR_VIDEO: 'photo-editor-video',
  PROCESSING_PROFILES: 'processing-profiles',
  PUBLIC_ERRORS: 'public-errors',
  REDESIGN: 'redesign',
  STAGING_STATUS: 'staging',
  STUDIO_AI_EDIT: 'studio-ai-edit',
  TEMPLATE_MODE_PROFILES: 'template-mode-profiles',
  VIDEO_STUDIO: 'video-studio',
  WISHLIST_BANNER: 'wishlist-banner',
};

export const BETA_CHANNELS = Set([]);
